import React from 'react';
// Components
import PersonalitiesContainer from '../../../containers/PersonalitiesContainer';


const Personalities = () => (
  <div className="ui grid">
    <div className="row">
      <div className="column">
        <PersonalitiesContainer />
      </div>
    </div>
  </div>
);

export default Personalities;



/** WEBPACK FOOTER **
 ** ./src/components/screens/personalities/Personalities.js
 **/